
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { AccountSettings } from "@/components/settings/AccountSettings";
import { SubscriptionManager } from "@/components/billing/SubscriptionManager";
import { SubscriptionFixer } from "@/components/billing/SubscriptionFixer";
import { OrganizationAccess } from "@/components/settings/OrganizationAccess";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Settings as SettingsIcon } from "lucide-react";

const Settings = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate("/auth?mode=signin");
      }
    };
    
    checkUser();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="flex items-center gap-4 mb-8">
          <Button
            variant="ghost"
            className="flex items-center gap-2"
            onClick={() => navigate("/dashboard")}
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Dashboard
          </Button>
          
          <div className="flex items-center gap-3">
            <SettingsIcon className="h-6 w-6 text-gray-600" />
            <h1 className="text-2xl font-bold text-gray-900">Account Settings</h1>
          </div>
        </div>

        <div className="space-y-8">
          <SubscriptionFixer />
          <OrganizationAccess />
          <AccountSettings />
          <SubscriptionManager />
        </div>
      </div>
    </div>
  );
};

export default Settings;
